import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceLightDriver extends PoolDevice implements PoolDeviceInterface {
    static minAutoFilterVersion = 21;
    static DeviceType = DeviceTypes.LIGHTDRIVER;
    static Icon = "cube";
    static PickerTitle = Locale.gettext("Light Driver");
}
